import angular from 'angular';
import leaveComponent from './leave.component';
import '../../less/pages/pto.less';
import TimesheetServices from '../timesheet/services/services';
import Common from '../../common/common';

let leaveModule = angular.module('leave', [
  Common.name,
  TimesheetServices.name,
  'chart.js'
])
.component('leave', leaveComponent);

export default leaveModule;




// WEBPACK FOOTER //
// ./client/pages/leave/leave.js